import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import useQuery from "../../hooks/useQuery";

import useStyles, { StyledRating } from "./collection-item.styles";

import QuickView from "../quick-view";
import Price from "../price";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const CollectionItem = ({ item }: { item: any }) => {
  const { pathname } = useLocation();
  const query = useQuery();

  const matches = useMediaQuery("(min-width:1200px)");

  query.set("productId", item.id);

  const classes = useStyles({
    isOnSale: item.isOnSale,
    image: item.imageDefault || item.imageGallery?.[0],
    matches,
  });

  const [isMouseOver, setIsMouseOver] = useState(false);

  const handleMouseEnter = () => {
    setIsMouseOver(true);
  };
  const handleMouseLeave = () => {
    setIsMouseOver(false);
  };

  return (
    <div
      className={classes.collectionItem}
      onMouseOver={handleMouseEnter}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className={classes.imageContainer}>
        {!item.imageDefault && item.imageGallery?.length === 0 ? (
          <div className={classes.noImage}>No Image</div>
        ) : (
          <div className={classes.image} />
        )}
        <div className={classes.badgeContainer}>
          {item.isSoldOut && (
            <span className={`${classes.badge} ${classes.soldoutBadge}`}>
              Soldout
            </span>
          )}
          {item.isPopular && (
            <span className={`${classes.badge} ${classes.popularBadge}`}>
              Popular
            </span>
          )}
          {item.isOnSale && (
            <span className={`${classes.badge} ${classes.onsaleBadge}`}>
              {item.discountRate && item.discountRate.toFixed(0)}% Sale
            </span>
          )}
        </div>
        {matches ? <QuickView item={item} isMouseOver={isMouseOver} /> : null}
        <Link
          className={classes.linkToItemDetail}
          to={`${pathname}/product?${query.toString()}`}
        />
      </div>
      <div className={classes.infoContainer}>
        <div className={classes.brand}>{item.brand}</div>
        <div className={classes.name}>{item.title}</div>
        <Price item={item} />
        <div className={classes.ratingContainer}>
          <span className={classes.rating}>
            <StyledRating
              name="read-only"
              value={item.averageRate}
              precision={0.5}
              readOnly
              size="small"
            />
          </span>
          <span className={classes.numberOfReviews}>
            {item.reviews?.length}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CollectionItem;
